import React from 'react';
import { Popper, Paper, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import { FORTA_BLUE } from '../../utils/colors';

import type { PopperPlacementType } from '@mui/material';

interface FHPopperProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
  placement?: PopperPlacementType;
  backgroundColor?: string;
  sx?: any;
  popperStyles?: any;
}

const FHPopper: React.FC<FHPopperProps> = ({
  anchorEl,
  open,
  onClose,
  children,
  placement = 'top-start',
  backgroundColor = FORTA_BLUE.light3,
  popperStyles = {},
  sx,
}) => {
  const id = open ? 'simple-popper' : undefined;

  return (
    <Popper
      id={id}
      open={open}
      anchorEl={anchorEl}
      placement={placement}
      sx={{ borderRadius: 1, ...popperStyles }}
    >
      <Paper
        data-testid="popper-paper"
        style={{
          padding: '16px',
          position: 'relative',
          borderRadius: '8px',
          backgroundColor,
          boxShadow: '0px 4px 4px 0px rgba(18, 78, 120, 0.25)',
        }}
        sx={sx}
      >
        <IconButton
          style={{ position: 'absolute', top: '8px', right: '8px', color: FORTA_BLUE.primary }}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
        {children}
      </Paper>
    </Popper>
  );
};

export default FHPopper;
